var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { settings } from "survey-core";
import { ReactElementFactory, SurveyActionBar, SurveyElementBase, SvgIcon } from "survey-react-ui";
var SearchComponent = /** @class */ (function (_super) {
    __extends(SearchComponent, _super);
    function SearchComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            filterString: _this.model.filterString || ""
        };
        return _this;
    }
    Object.defineProperty(SearchComponent.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    SearchComponent.prototype.getStateElement = function () {
        return this.model;
    };
    SearchComponent.prototype.renderElement = function () {
        var _this = this;
        if (!this.model.isVisible)
            return null;
        var onChange = function (e) {
            var root = settings.environment.root;
            if (e.target === root.activeElement) {
                _this.model.filterString = e.target.value;
            }
        };
        return (React.createElement("div", { className: "svc-search" },
            React.createElement("div", { className: "svc-search__search-icon" },
                React.createElement(SvgIcon, { iconName: "icon-search", size: "auto" })),
            React.createElement("input", { type: "text", className: "svc-search__input", "aria-label": this.model.filterStringPlaceholder, placeholder: this.model.filterStringPlaceholder, value: this.state.filterString, onChange: onChange, tabIndex: this.model.getTabIndex() }),
            React.createElement("div", { className: "svc-search__toolbar" },
                React.createElement("div", { className: "svc-search__toolbar-counter" }, this.model.matchCounterText),
                React.createElement(SurveyActionBar, { model: this.model.searchActionBar }))));
    };
    return SearchComponent;
}(SurveyElementBase));
export { SearchComponent };
ReactElementFactory.Instance.registerElement("svc-search", function (props) {
    return React.createElement(SearchComponent, props);
});
